import { render, staticRenderFns } from "./BrandWall.vue?vue&type=template&id=69668c7c&scoped=true&"
import script from "./BrandWall.vue?vue&type=script&lang=js&"
export * from "./BrandWall.vue?vue&type=script&lang=js&"
import style0 from "./BrandWall.vue?vue&type=style&index=0&id=69668c7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69668c7c",
  null
  
)

export default component.exports